import type * as React from "react";
import type { useRouter } from "@tanstack/react-router";

import { ProfileContext, useProfileContext } from "./use-profile-context";

export function ProfileProvider({
	children,
	router,
	values,
}: {
	children: React.ReactNode;
	router: ReturnType<typeof useRouter>;
	values: {
		tenant: string | null | undefined;
		userId: string | null | undefined;
		timeZone?: string;
		defaultSidebarOpen: boolean;
	};
}) {
	return (
		<ProfileContext
			value={useProfileContext({
				...values,
				router,
			})}
		>
			{children}
		</ProfileContext>
	);
}
